import { STUDIO_BASE } from '@/features/studio/lib/studio-paths'

/** 制片项目路由前缀（同域 /studio/productions） */

export function productionHubPath(): string {
  return `${STUDIO_BASE}/productions`
}

export function productionBasePath(productionId: string): string {
  return `${STUDIO_BASE}/productions/${productionId}`
}
